import { useState } from 'react';

import { Button } from '@/components/ui/Button';
import { PageHeader } from '@/components/ui/PageHeader';

import { State } from '../State';

/**
 * Shown on demand, not inline: PageHeader renders a page's h1 and names the
 * browser tab, and this page already has both. Behind the button, the page
 * keeps one h1 until somebody asks to see another.
 */
export function PageHeaderExamples() {
  const [shown, setShown] = useState(false);

  return (
    <State
      title="With and without the primary action"
      note="Each renders a page's own h1 and renames the tab, so they are shown on request."
    >
      <Button variant="secondary" size="sm" onClick={() => setShown((s) => !s)}>
        {shown ? 'Hide the page headers' : 'Show the page headers'}
      </Button>

      {shown ? (
        <>
          <PageHeader
            title="Sample page"
            description="What this page is for, in one line."
            action={<Button>New thing</Button>}
          />
          <PageHeader title="Sample page" description="A page that only shows things." />
        </>
      ) : null}
    </State>
  );
}
